import script from "./FAddComment.vue?vue&type=script&lang=ts&setup=true"
export * from "./FAddComment.vue?vue&type=script&lang=ts&setup=true"

import "./FAddComment.vue?vue&type=style&index=0&id=494a6e12&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-494a6e12"]])

export default __exports__